import React from 'react';

interface PageTitleProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ 
  title, 
  subtitle,
  backgroundImage = '/images/hero-bg.jpg' 
}) => {
  return (
    <div 
      className="hero-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">{title}</h1>
        {subtitle && <p className="text-xl md:text-2xl max-w-3xl mx-auto">{subtitle}</p>}
      </div>
    </div>
  );
};

export default PageTitle;